import Axolotl from '../../../../assets/svg/stickers/axolotl.svg';
import Board from '../../../../assets/svg/stickers/board.svg';
import Clap from '../../../../assets/svg/stickers/clap.svg';
import Crown from '../../../../assets/svg/stickers/crown.svg';
import Curiday from '../../../../assets/svg/stickers/curiday.svg';
import CuripodLogo from '../../../../assets/svg/stickers/curipodLogo.svg';
import DrawHand from '../../../../assets/svg/stickers/drawHand.svg';
import EmbraceEmoji from '../../../../assets/svg/stickers/embraceEmoji.svg';
import ExplanationMark from '../../../../assets/svg/stickers/explanationMark.svg';
import ExplotionEmoji from '../../../../assets/svg/stickers/explotionEmoji.svg';
import Friday from '../../../../assets/svg/stickers/friday.svg';
import InvestigateEmoji from '../../../../assets/svg/stickers/investigateEmoji.svg';
import Lightbold from '../../../../assets/svg/stickers/lightbold.svg';
import LoveEmoji from '../../../../assets/svg/stickers/loveEmoji.svg';
import Monday from '../../../../assets/svg/stickers/monday.svg';
import NerdEmoji from '../../../../assets/svg/stickers/nerdEmoji.svg';
import PartyEmoji from '../../../../assets/svg/stickers/partyEmoji.svg';
import Pointer from '../../../../assets/svg/stickers/pointer.svg';
import PraiseEmoji from '../../../../assets/svg/stickers/praiseEmoji.svg';
import QuestionMark from '../../../../assets/svg/stickers/questionMark.svg';
import Reflect from '../../../../assets/svg/stickers/reflect.svg';
import Robot from '../../../../assets/svg/stickers/robot.svg';
import Rocket from '../../../../assets/svg/stickers/rocket.svg';
import Saturday from '../../../../assets/svg/stickers/saturday.svg';
import SleepEmoji from '../../../../assets/svg/stickers/sleepEmoji.svg';
import Stars from '../../../../assets/svg/stickers/stars.svg';
import StarStruckEmoji from '../../../../assets/svg/stickers/starStruckEmoji.svg';
import Sunday from '../../../../assets/svg/stickers/sunday.svg';
import ThumbsUp from '../../../../assets/svg/stickers/thumbsUp.svg';
import Thursday from '../../../../assets/svg/stickers/thursday.svg';
import Tuesday from '../../../../assets/svg/stickers/tuesday.svg';
import VotingLong from '../../../../assets/svg/stickers/votingLong.svg';
import VotingRound from '../../../../assets/svg/stickers/votingRound.svg';
import Wednesday from '../../../../assets/svg/stickers/wednesday.svg';
import theme from '../../../../assets/theme';

export type Figure = {
  value: string;
  colors?: string[];
  width: number;
  height: number;
  name: string;
};
const questionMark = {
  name: 'questionMark',
  value: QuestionMark.src,
  colors: [],
  width: 165,
  height: 229,
};
const explamationMark = {
  name: 'explanationMark',
  value: ExplanationMark.src,
  colors: [],
  width: 59,
  height: 242,
};

const curipodLogo = {
  name: 'curipodLogo',
  value: CuripodLogo.src,
  colors: [theme.colors.orange],
  width: 200,
  height: 200,
};

const starStruckEmoji = {
  name: 'starStruckEmoji',
  value: StarStruckEmoji.src,
  colors: [],
  width: 169,
  height: 159,
};

const praiseEmoji = {
  name: 'praiseEmoji',
  value: PraiseEmoji.src,
  colors: [],
  width: 200,
  height: 203,
};

const loveEmoji = {
  name: 'loveEmoji',
  value: LoveEmoji.src,
  colors: [],
  width: 200,
  height: 200,
};
const stars = {
  name: 'stars',
  value: Stars.src,
  colors: [],
  width: 249,
  height: 270,
};
const board = {
  name: 'board',
  value: Board.src,
  colors: [],
  width: 200,
  height: 230,
};
const explotionEmoji = {
  name: 'explotionEmoji',
  value: ExplotionEmoji.src,
  colors: [],
  width: 200,
  height: 259,
};

const crown = {
  name: 'crown',
  value: Crown.src,
  colors: [],
  width: 445,
  height: 329,
};
const rocket = {
  name: 'rocket',
  value: Rocket.src,
  colors: [],
  width: 200,
  height: 199,
};

const embraceEmoji = {
  name: 'embraceEmoji',
  value: EmbraceEmoji.src,
  colors: [],
  width: 200,
  height: 120,
};

const thumbsUp = {
  name: 'thumbsUp',
  value: ThumbsUp.src,
  colors: [],
  width: 210,
  height: 174,
};
const investigateEmoji = {
  name: 'investigateEmoji',
  value: InvestigateEmoji.src,
  colors: [],
  width: 277,
  height: 278,
};
const clap = {
  name: 'clap',
  value: Clap.src,
  colors: [],
  width: 145,
  height: 156,
};
const pointer = {
  name: 'pointer',
  value: Pointer.src,
  colors: [],
  width: 183,
  height: 226,
};
const robot = {
  name: 'robot',
  value: Robot.src,
  colors: [],
  width: 200,
  height: 262,
};
const nerdEmoji = {
  name: 'nerdEmoji',
  value: NerdEmoji.src,
  colors: [],
  width: 201,
  height: 279,
};
const sleepEmoji = {
  name: 'sleepEmoji',
  value: SleepEmoji.src,
  colors: [],
  width: 200,
  height: 207,
};
const partyEmoji = {
  name: 'partyEmoji',
  value: PartyEmoji.src,
  colors: [],
  height: 205,
  width: 200,
};
const drawHand = {
  name: 'drawHand',
  value: DrawHand.src,
  colors: [],
  width: 179,
  height: 170,
};
const lightbold = {
  name: 'lightbold',
  value: Lightbold.src,
  colors: [],
  width: 200,
  height: 200,
};
const monday = {
  name: 'monday',
  value: Monday.src,
  colors: [],
  width: 200,
  height: 100,
};

const tuesday = {
  name: 'tuesday',
  value: Tuesday.src,
  colors: [],
  width: 200,
  height: 100,
};

const wednesday = {
  name: 'wednesday',
  value: Wednesday.src,
  colors: [],
  width: 200,
  height: 100,
};
const thursday = {
  name: 'thursday',
  value: Thursday.src,
  colors: [],
  width: 200,
  height: 100,
};
const friday = {
  name: 'friday',
  value: Friday.src,
  colors: [],
  width: 200,
  height: 100,
};
const saturday = {
  name: 'saturday',
  value: Saturday.src,
  colors: [],
  width: 200,
  height: 100,
};
const sunday = {
  name: 'sunday',
  value: Sunday.src,
  colors: [],
  width: 200,
  height: 100,
};
const curiday = {
  name: 'curiday',
  value: Curiday.src,
  colors: [],
  width: 200,
  height: 150,
};

const reflect = {
  name: 'reflect',
  value: Reflect.src,
  colors: [],
  width: 200,
  height: 150,
};

const axolotl = {
  name: 'reflect',
  value: Axolotl.src,
  colors: [],
  width: 250,
  height: 160,
};
const votingRound = {
  name: 'reflect',
  value: VotingRound.src,
  colors: [],
  width: 200,
  height: 200,
};
const votingLong = {
  name: 'reflect',
  value: VotingLong.src,
  colors: [],
  width: 250,
  height: 100,
};

const figures: Figure[] = [
  pointer,
  thumbsUp,
  clap,
  questionMark,
  rocket,
  drawHand,
  explamationMark,
  lightbold,
  stars,
  crown,
  board,
  investigateEmoji,
  embraceEmoji,
  explotionEmoji,
  partyEmoji,
  sleepEmoji,
  nerdEmoji,
  praiseEmoji,
  loveEmoji,
  starStruckEmoji,
  curipodLogo,
  robot,
  monday,
  tuesday,
  wednesday,
  thursday,
  friday,
  saturday,
  sunday,
  curiday,
  reflect,
  axolotl,
  votingLong,
  votingRound,
];

export default figures;
